import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'// 首页
//import notice from '@/components/notice'// 艾灸常识
//import index from '@/components/index'// 智能体检
import category from '@/components/category'// 艾灸方法
import acupoint from '@/components/acupoint'// 穴位查找

// 如果使用模块化机制编程，导入 Vue 和 VueRouter，要调用 Vue.use(VueRouter)
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: HomePage,
      meta: {
        title: '九洲福养生助手'
      }
    }, {
      path: '/category',
      name: 'category',
      component: category,
      meta: {
        title: '护理分类'
      }
    }, {
      path: '/acupoint',
      name: 'acupoint',
      component: acupoint,
      meta: {
        title: '穴位查找'
      }
    }, {
      path: '/acupoint-info',
      name: 'acupointInfo',
      component: () => import('@/components/acupointInfo'),
      meta: {
        title: '穴位信息'
      }
    },{
      path: '/acupoint-info1',
      name: 'acupointInfo1',
      component: () => import('@/components/acupointInfo1'),
      meta: {
        title: '穴位信息'
      }
    }, {
      path: '/nursing-list',
      name: 'nursingList',
      component: () => import('@/components/nursingList'),
      meta: {
        title: ''
      }
    }, {
      path: '/nursing-info',
      name: 'nursingInfo',
      component: () => import('@/components/nursingInfo'),
      meta: {
        title: ''
      }
    }  
  ],
  //mode: 'history' // 去掉路径中的“#”
})



// WEBPACK FOOTER //
// ./src/router/index.js